import { useState, useCallback } from "react";
import { PrivacyPolicyAPI } from "../libs/http-service/api/LearnLocal.api";

export const usePrivacyPolicy = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPrivacyPolicy = useCallback(async (params) => {
    setLoading(true);
    setError(null);
    try {
      const response = await PrivacyPolicyAPI.getPrivacyPolicy(params);
      if (response?.status && response?.data?.content?.length > 0) {
        // The API returns a list, the user screenshot shows the first item is the policy
        setData(response.data.content[0]);
      } else {
        setError("No privacy policy content found.");
      }
    } catch (err) {
      setError("Failed to fetch privacy policy. Please try again.");
      console.error("Privacy Policy Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, fetchPrivacyPolicy };
};
